export default __webpack_public_path__ + "static/media/step-4.2bba5cd0.svg";